function parseIntoKeyList(cookieStr) {
  return cookieStr.split(';').map((el) => el.split('=', 1));
}

function resetCookie(key) {
  // we do not manage cookies set with other values in the path then '/'.
  // This should be addressed at some point.
  document.cookie = `${key}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
}

export function clearCookies() {
  parseIntoKeyList(document.cookie).forEach(resetCookie);
}

export function clearStorage() {
  localStorage.clear();
}
